import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { AppConstant } from 'src/app/shared/constants/app.constant';
import { CUSTOME_API_TIME_OUT } from './un-authenticate-api';

@Injectable({
  providedIn: 'root'
})
export class HttpTimeoutInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let timeOut = AppConstant.NETWORK_TIMEOUT;
    if (CUSTOME_API_TIME_OUT.indexOf(request.url)!==-1){
      timeOut=1200000;
    }
    return next.handle(request).pipe(
      timeout(timeOut)
    );
  }
}
